module.exports = __webpack_public_path__ + "static/media/computer_audio.5ea00efa.png";